var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.0113525,12.4547424c-0.5535278-2.0559692-2.1746216-3.677063-4.2306519-4.2305908 c-3.7561646-1.0280151-18.7808228-1.0280151-18.7808228-1.0280151s-15.0245972,0-18.7807617,0.9884644 c-2.0164795,0.5535278-3.677124,2.2141724-4.2306519,4.2701416C0,16.210907,0,24.0000305,0,24.0000305 s0,7.8286133,0.9884644,11.5452271c0.5535278,2.0560303,2.1746216,3.677063,4.2306519,4.2306519 c3.7956543,1.0279541,18.7807617,1.0279541,18.7807617,1.0279541s15.0246582,0,18.7808228-0.9884644 c2.0560303-0.5535278,3.677124-2.1746216,4.2306519-4.2305908c0.9884644-3.7561646,0.9884644-11.5452881,0.9884644-11.5452881 S48.0393066,16.210907,47.0113525,12.4547424z M19.2157593,31.1960144V16.8039856l12.4941406,7.1960449L19.2157593,31.1960144z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMedium);
export default __webpack_public_path__ + "static/media/youtube--medium.e4da0fcd89a586770e2ca935ae69b0aa.svg";
export { ForwardRef as ReactComponent };